import { render, staticRenderFns } from "./ColumnMappingPreviewValue.vue?vue&type=template&id=8d588f80&scoped=true&lang=html&"
import script from "./ColumnMappingPreviewValue.vue?vue&type=script&lang=js&"
export * from "./ColumnMappingPreviewValue.vue?vue&type=script&lang=js&"
import style0 from "./ColumnMappingPreviewValue.vue?vue&type=style&index=0&id=8d588f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d588f80",
  null
  
)

export default component.exports